import { Injectable } from '@angular/core';

@Injectable()
export class QuestionnaireTypeService {

  questionTypesList : QuestionTypes[] = [{
    questionType : 'Subjective', displayValue : 'Short Text', icon : '../../assets/images/short-ans-icon.svg'},{//1
    questionType : 'TextArea', displayValue : 'Long Text', icon : '../../assets/images/long-ans-icon.svg'},{//2
    questionType : 'WholeNumMax500', displayValue : 'Number', icon : '../../assets/images/num-icon.svg'},{//3
    questionType : 'Radio', displayValue : 'Single Choice', icon : '../../assets/images/single-choice-icon.svg'},{//4
    questionType : 'Checkbox', displayValue : 'Multiple Choice', icon : '../../assets/images/multiple-choice-icon.svg'},{ //5
    questionType : 'Selected Dropdown', displayValue : 'Dropdown', icon : '../../assets/images/dropdown-icon.svg'},{  //6
    questionType : 'Calendar', displayValue : 'Calendar', icon : '../../assets/images/calendar-icon.svg'},{  //7
    questionType : 'Map', displayValue : 'Location', icon : '../../assets/images/map-icon.svg'},{   //8
    questionType : 'Picture Input', displayValue : 'Picture Input', icon : '../../assets/images/picture-icon.svg'},{ //9
    questionType : 'Button', displayValue : 'Cascading Dropdown', icon : '../../assets/images/cascading-dropdown-icon.svg'},{//10
    questionType : 'Rating', displayValue : 'Rating', icon : '../../assets/images/rating-icon.svg'},{ //11
    questionType : 'Time', displayValue : 'Time', icon : '../../assets/images/time-icon.svg'},{//12
    questionType : 'Emoji', displayValue : 'Emoji', icon : '../../assets/images/emoji-icon.svg'},{ //13
    // questionType : 'Range', displayValue : 'Range', icon : '../../assets/images/range.svg'},{//14
    questionType : 'Break', displayValue : 'Break', icon : '../../assets/images/section-break-icon.svg'},{ //15
    questionType : 'Rank', displayValue : 'Rank', icon : '../../assets/images/rank-icon.svg'},{ //16
    questionType : 'Audio', displayValue : 'Audio', icon : '../../assets/images/audio-icon.svg'},{ //17
    questionType : 'Video', displayValue : 'Video', icon : '../../assets/images/video-icon.svg'},{ //18
    questionType : 'Document', displayValue : 'Document', icon : '../../assets/images/document-icon.svg'},{ //19
    questionType : 'Repeater_QT', displayValue : 'Repeater_QT', icon : '../../assets/images/repeater-qt-icon.svg'} //20
  ];
  
  constructor() { }

  getQuestionsTypesList(){
    return this.questionTypesList;
  }
}

class QuestionTypes {
  questionType : string;
  displayValue : string;
  icon : string;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/questionnaire-type-service.service.ts